import React, { useCallback, useMemo } from "react";
import { isString } from "lodash";

import { Input, IDropdownOption, SelectColor } from "@treelab/panda";

import { IFilterValue } from "../../../../../../types/form-type";
import { ITableColumn, ColumnType } from "../../../../../../types/table-type";

import { ChipPlain } from "./styled";
import { getIsMulti } from "../../../../../../utils/form_secondary";

interface IProps {
  name: string;
  isDisabled?: boolean;
  value: IFilterValue;
  column: ITableColumn<ColumnType.SELECT> | ITableColumn<ColumnType.MULTI_SELECT>;
  onChange: (value: { [key: string]: any }) => void;
}

// 适用于 多选 单选
const SelectSelector: React.FC<IProps> = ({ value, column, name, onChange }) => {
  const {
    type,
    typeOptions: { options },
  } = column;
  const { filterString, filterCondition } = value;

  const isMulti = useMemo(() => {
    return getIsMulti(type, filterCondition);
  }, [type, filterCondition]);

  const handleSelectChange = useCallback(
    (data: string[] | string) => {
      onChange({ filterString: data });
    },
    [onChange]
  );

  if (isMulti) {
    return (
      <Input.Select
        meta={{}}
        options={options.map<IDropdownOption>(({ optionId, name: name_, color }) => {
          return {
            name: name_,
            params: {
              color,
            },
            value: optionId,
          };
        })}
        input={{
          name: `${name}.multiSelect`,
          onChange: handleSelectChange,
          value: Array.isArray(filterString) ? filterString : "",
        }}
        isRequired={false}
        includeSearch={true}
        isMulti={isMulti}
        renderValues={(values: string[]): React.ReactNode => {
          return (
            <>
              {values.map((value_) => {
                const option = options.find(({ optionId }) => value_ === optionId);
                if (!option) return null;
                return (
                  <ChipPlain key={option.optionId} color={option.color as SelectColor}>
                    {option.name}
                  </ChipPlain>
                );
              })}
            </>
          );
        }}
        renderItem={(option: IDropdownOption): React.ReactNode => {
          return <ChipPlain color={option.params.color}>{option.name}</ChipPlain>;
        }}
      />
    );
  }
  return (
    <Input.Select
      isRequired={false}
      meta={{}}
      input={{
        name: `${name}.select`,
        onChange: handleSelectChange,
        value: isString(filterString) ? filterString : "",
      }}
      options={options.map<IDropdownOption>(({ optionId, name: name_, color }) => {
        return {
          name: name_,
          params: {
            color,
          },
          value: optionId,
        };
      })}
      renderValues={(values: string[]): React.ReactNode => {
        return (
          <>
            {values.map((value_) => {
              const option = options.find(({ optionId }) => value_ === optionId);
              if (!option) return null;
              return (
                <ChipPlain key={option.optionId} color={option.color as SelectColor}>
                  {option.name}
                </ChipPlain>
              );
            })}
          </>
        );
      }}
      renderItem={(option: IDropdownOption): React.ReactNode => {
        return <ChipPlain color={option.params.color}>{option.name}</ChipPlain>;
      }}
    />
  );
};

export default SelectSelector;
